import '../../../style/mobile/store/MStoreProduct.scss';
import { useState } from 'react';
import MspTab1 from './MspTab1';
import MspTab2 from './MspTab2';
import MspTab3 from './MspTab3';
import { useSelector } from 'react-redux';


const MStoreProduct=({ID})=>{
  const state = useSelector((state) => state.default);
  let data;
  for (let i = 0; i < state.ExamData.length; i++) {
    if (state.ExamData[i].id === Number(ID)) {
      data = state.ExamData[i];
    }
  }

  const [activeTab,setActiveTab] = useState(1);

  const changeTab1=()=>{
    setActiveTab(1);
    document.querySelector(".MStoreProduct-tab-container-bg").style.right="0px";
    // document.querySelectorAll(".MStoreProduct-tab-container-item")[0].style.color="#fff";
  }

  const changeTab2=()=>{
    setActiveTab(2);
    document.querySelector(".MStoreProduct-tab-container-bg").style.right="33.3%";
    // document.querySelectorAll(".MStoreProduct-tab-container-item")[1].style.color="#fff";
  }

  const changeTab3=()=>{
    setActiveTab(3);
    document.querySelector(".MStoreProduct-tab-container-bg").style.right="66.6%";
    // document.querySelectorAll(".MStoreProduct-tab-container-item")[2].style.color="#fff";
  }
  return(
    <div className="MStoreProduct">
      <div className="MStoreProduct-img-container">
        <img src={data.img} alt="exam-img"/>
      </div>
      <div className="MStoreProduct-title">{data.name}</div>
      <div className="MStoreProduct-tab-container">
        <div className="MStoreProduct-tab-container-bg"></div>
        <div style={(activeTab===1)?{color:"#fff"}:null} className="MStoreProduct-tab-container-item" onClick={changeTab1}>توضیحات آزمون</div>
        <div style={(activeTab===2)?{color:"#fff"}:null} className="MStoreProduct-tab-container-item" onClick={changeTab2}>ویژگی‌ها</div>
        <div style={(activeTab===3)?{color:"#fff"}:null} className="MStoreProduct-tab-container-item" onClick={changeTab3}>ضمیمه</div>
      </div>
      <div className="MStoreProduct-tab-body">
        {activeTab===1 && <MspTab1 data={data}/>}
        {activeTab===2 && <MspTab2 data={data}/>}
        {activeTab===3 && <MspTab3 data={data}/>}
      </div>
      <div className="MStoreProduct-add-to-cart-btn-container">
        <div className="MStoreProduct-add-to-cart-btn-container-text">
          اضافه کردن به سبد خرید
        </div>
        <div className="MStoreProduct-add-to-cart-btn-container-price-info">
          <div className="MStoreProduct-add-to-cart-btn-container-price-info-main-price">
            100000
            <span>تومان</span>
          </div>
          <div className="MStoreProduct-add-to-cart-btn-container-price-info-discount">
            10%
            تخفیف
          </div>
          <div className="MStoreProduct-add-to-cart-btn-container-price-info-discounted-price">
            90000
            <span>تومان</span>
          </div>
        </div>
      </div>
    </div>
  )
}

export default MStoreProduct;